import { useContext, useEffect, useState } from "react";
import Header from '../components/Header/Header';
import { EditIcon } from "../components/Icons/EditIcon";
import { ChevronLeft, ChevronRight, NextPage, BackPage, ArrowDown } from "../components/Icons/PaginationIcons";
import { ItemCard } from '../components/ItemCard/ItemCard';
import EntityProjectsContext from '../context/EntityProjects.context';
import { useDispatch } from 'react-redux';

const Page1 = () => {
  const dispatch = useDispatch();
  const { infos, setInfos, setPageToRender, pageToRender, projectsPage1: projects } = useContext(EntityProjectsContext);
  const [search, setSearch] = useState('');

  const [paginatorIsOpen, setPaginatorIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [registerPerPage, setRegisterPerPage] = useState(10);

  const setRowsPerPage = (rowsPerPage) => {
    setCurrentPage(1);
    setRegisterPerPage(rowsPerPage);
    setPaginatorIsOpen(false);
  };

  const [renderProjects, setRenderProjects] = useState([]);

  const [firstItemIndex, setFirstItemIndex] = useState(0);
  const [lastItemIndex, setLastItemIndex] = useState(0);

  const handleRenderProjects = (registersPerPage, page = 1) => {
    setSearch('');
    const startIndex = (page - 1) * registersPerPage;
    const endIndex = startIndex + registersPerPage;
    const filteredProjects = projects.slice(startIndex, endIndex);

    setRenderProjects(filteredProjects);
    setFirstItemIndex(startIndex);
    setLastItemIndex(Math.min(endIndex, projects.length) - 1);
    setCurrentPage(page);
    setRegisterPerPage(registersPerPage);
  };

  useEffect(() => {
    handleRenderProjects(registerPerPage, currentPage);
  }, [registerPerPage, projects, currentPage]);

  useEffect(() => {
    if (projects.length === 1) {
      redirectToProject(projects[0]);
    }
  }, [projects]);

  useEffect(() => {
    if (search === '') {
      handleRenderProjects(registerPerPage);
      return
    }
    const filteredProjects = projects.filter(project => {
      return project.project_name.toLowerCase().includes(search.toLowerCase()) || project.description.toLowerCase().includes(search.toLowerCase())
    });
    setRenderProjects(filteredProjects);
  }, [search, projects]);

  const onBackPage = () => {
    if (currentPage === 1) return;
    handleRenderProjects(registerPerPage, currentPage - 1);
  };
  const onNextPage = () => {
    if (currentPage === Math.ceil(projects.length / registerPerPage)) return;
    handleRenderProjects(registerPerPage, currentPage + 1);
  };
  const onBack = () => {
    handleRenderProjects(registerPerPage, 1);
  };
  const onNext = () => {
    handleRenderProjects(registerPerPage, (projects.length / registerPerPage));
  };

  const redirectToProject = (project) => {
    dispatch({ type: 'UPDATE_SESSION', key: 'pdc_project_friendly_url', value: project.project_url });
    dispatch({ type: 'UPDATE_SESSION', key: 'pdc_project_id', value: project.id });
    setPageToRender(2)
  };


  return (
    <div className="entity-projects-page">
      <div className='entity-projects-container'>
        <Header
          mode='1'
          onClick={() => {
            setPageToRender('goback')
            dispatch({ type: 'UPDATE_SESSION', key: 'pdc_project_friendly_url', value: null });
            dispatch({ type: 'UPDATE_SESSION', key: 'pdc_project_id', value: null });
          }}
          color={infos.primary_color}
          title={infos.header.title}
          subtitle={infos.header.subtitle}
          logoURL={infos.header.logoURL}
        />

        <div className="entity-projects-background">
          <div className="entity-projects-content">
            <div className="search-bar-new">
              <div>
                <EditIcon />
                <div>Projetos da Entidade</div>
              </div>
              <input onChange={(e) => setSearch(e.target.value)} type="text" placeholder="Pesquisa" />
            </div>
            <div className="entity-projects-grid">
              {renderProjects.map((project, index) => {
                return <ItemCard
                  title={project.project_name}
                  description={project.description}
                  imageURL={project.project_image}
                  onClick={() => redirectToProject(project)}
                  isActive={project.status}
                  imageUF={project.uf_img}
                />
              })}
            </div>
            <div className="pagination-container">
              <div>
                <div className="select-page-size">
                  <p>Por Página: {registerPerPage}</p>

                  <button onClick={() =>
                    setPaginatorIsOpen(!paginatorIsOpen)
                  }>
                    <ArrowDown />
                  </button>

                  {
                    paginatorIsOpen && (
                      <div onMouseLeave={() => setPaginatorIsOpen(false)}>
                        {
                          ['10', '15', '20', '25', '30', '100'].map((rowsPerPage) => {
                            return <p onClick={() => setRowsPerPage(rowsPerPage)}>{rowsPerPage}</p>
                          })
                        }
                      </div>
                    )
                  }
                </div>

                <p>{firstItemIndex + 1}-{lastItemIndex + 1} de {projects.length}</p>
                <button onClick={onBackPage}>
                  <ChevronLeft />
                </button>
                <button onClick={onNextPage}>
                  <ChevronRight />
                </button>
                <button onClick={onBack}>
                  <BackPage />
                </button>
                <button onClick={onNext}>
                  <NextPage />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}


export default Page1;
